import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import { fuseAnimations } from '@fuse/animations';
///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_focus } from 'app/idiomas/i18n/focus/focus.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {MatSnackBar} from '@angular/material/snack-bar';

import * as backInter from 'app/auth/auth-data.model';
import { GruposService } from 'app/main/wizard-cgo/services/grupos.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'crearg',
  templateUrl: './crearg.component.html',
  styleUrls: ['./crearg.component.scss']
})
export class CreargComponent implements OnInit {
  @Output() CambioTab: EventEmitter<boolean> = new EventEmitter();
  private eventsSubscription: any
  @Input() datosInfoGrupo: Observable<any>;
  productoFocus: backInter.prodFocusArea;
  infoGrupo: backInter.infoGrupoFocusArea;
  filtrosFocusArea: backInter.filtrosGruposFocus[] = [];
  nombreEmpresa: string;

  mostrar=false;
  idGrupoBD:string;
  idiomaActual:string;

  arregloBoolean: boolean[]=[
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]
  toppings = new FormControl();
  toppingList: string[] = [
    'Género',
    'Antiguedad',
    'Páis',
    'Área',
    'Cargo y/o función',
    'Niveles Geograficos',
    'Niveles Jerarquicos',
    'Condición de trabajo',
    'Grado académico',
    'Tipo de contrato',
    'Tipo de jornada de trabajo',
    'Rotación de turno',

  ];
  //etiquetas para encontrar los textos de traduccion
  mensajesTraducirKeys: string[] = [
    'LANDINFOCUS.GRUPOS.NOMBRE_OK',
    'LANDINFOCUS.GRUPOS.DESCRIPCION_OK',
  ]
  //variables que tomaran las traducciones indicadas en la variable anterior
  //deben ir en el mismo orden
  mensajesTraducirTS = {
    nombre_ok: '',
    descripcion_ok: '',

  };

  constructor(
    private gruposService: GruposService,
    private wizardService: WizardService,
    private _snackBar: MatSnackBar,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService
  ) {
    lang_focus.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
     this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
  }

  ngOnInit() {
    this. obtieneFocusActual();
    this.getFiltrosGrupos();
    this.traduceTextosTS()
    this.eventsSubscription = this.datosInfoGrupo.subscribe( (datos) => {
      console.log("actualiza datos de un grupo ");
      console.log(datos);
      this.infoGrupo=datos;

    })

  }



  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
    // this.idiomaActual = this.translateSrv.currentLang;
    switch(this.translateSrv.currentLang){
      case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
      default: this.idiomaActual = 'en';
    }
  }
  MostrarPais(numero: number)
  {
    this.arregloBoolean[numero]=!this.arregloBoolean[numero];
    console.log
    this.mostrar=true;
  }


  obtieneFocusActual(){
    /// obtiene el producto certificar vigente
    this.gruposService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsFocusArea:backInter.prodFocusArea[] = data.productosFocusArea;
      var BreakException = {};
      try {
        prodsFocusArea.forEach( (producto) => {
          let fecha = producto.fechaFocus;
          let idProducto = producto.idFocusArea;
          console.log(fecha+'-'+parseInt(localStorage.getItem('fechaProducto'))+'*'+idProducto+'-'+ localStorage.getItem('productoID'));
          if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
            this.productoFocus = producto;
            console.log(this.productoFocus);
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      // this.colaboradoresService.getStatusColaboradores(this.productoCertificar.fechaCertificar).subscribe( (data: backInter.getStatusIndiv) => {
      //   if(data.estatus === 3)
      //     this.pasoCompleto = true;
      //
      // });
      //obtiene los colaboradores guardados y fecha de carga

      //obtiene nombre empresa
      this.wizardService.getInfoEmpresa().subscribe((data:backInter.infoEmpresa) => {
        this.nombreEmpresa = data.data.nombreEmpresa;
      });
    }, error  => {
      console.log("error al recuperar focusarea vigente");
    });
  }



  CrearGrupoFocus(texto, tipo: number){
console.log(this.idGrupoBD);
    if(texto.target.value.length > 0){
      if(this.idGrupoBD ||this.infoGrupo){
        console.log("entro a ctualizar");
       this.actualizarInfoGrupoFocus(texto.target.value, tipo)


      }
      else{

      this.GuardaGrupoBD(texto.target.value, tipo);
        console.log("entro a guadar");
      }

    }
}



  GuardaGrupoBD(texto: string, tipo: number){
    let  encuestaid= localStorage.getItem('encuestaID');
    let  nombre="";
    let  descripcion="";
    switch(tipo){
      case 1:
      nombre = texto;

      break;
      case 2:
      descripcion= texto;

      break;
    }
    let datos= {encuestaId: encuestaid, nombre: nombre, descripcion: descripcion };
    console.log(datos);
    this.gruposService.getCrearGrupoFocus(datos).subscribe((data: any)=> {
      console.log(data);
      this.idGrupoBD= data.grupo._id;
      console.log(data.grupo._id);


      this.CambioTab.emit(true);
      switch(tipo){
        case 1:
        if(data.success){
          this.openSnackBar(this.mensajesTraducirTS.nombre_ok, "OK");

          console.log("se guardo correctamente");
        }
        break;
        case 2:
        if(data.success){
          this.openSnackBar(this.mensajesTraducirTS.descripcion_ok, "OK");
          console.log(data);
          console.log("se guardo correctamente");
        }
        break;
      }


    });
  }

  actualizarInfoGrupoFocus(texto: string, tipo: number){
    let  encuestaid= localStorage.getItem('encuestaID');
    let  nombre="";
    let  descripcion="";
    let idgrupo:string;
    if(this.infoGrupo){
      this.idGrupoBD= this.infoGrupo.data._id;
    }
    let datos= {grupoId: this.idGrupoBD};
    this.gruposService.getInfoGrupoFocus(datos).subscribe((data: backInter.infoGrupoFocusArea) => {

      console.log(data);
      switch(tipo){
        case 1:
        nombre = texto;
        descripcion= data.data.descripcion ;

          this.openSnackBar(this.mensajesTraducirTS.nombre_ok, "OK");

          console.log("se guardo correctamente");


        break;
        case 2:
        nombre = data.data.nombre;
        descripcion= texto;

          this.openSnackBar(this.mensajesTraducirTS.descripcion_ok, "OK");

          console.log("se guardo correctamente");


        break;
      }
      let datos= {nombre: nombre, descripcion: descripcion };
      console.log(datos);
      this.gruposService.actualizarInfoGrupoFocus(datos,data.data._id).subscribe((data2:any) => {
        console.log(data2);
        this.CambioTab.emit(true);

      });
    });


  }






  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


   getFiltrosGrupos(){
  this.gruposService.getFiltrosGruposFocusArea().subscribe((data: backInter.getFiltrosGruposFocusAreaAll) => {
    console.log(data);
  this.filtrosFocusArea= data.resultado;

  });

}






}
